@if (totalToBurnCount) {
    <h2 i18n>Draw {{ burnedCardsCount + 1 }}/{{ totalToBurnCount }} face down card from shoe</h2>
} @else {
    <h2 i18n>Draw face up card from shoe</h2>
}

<div class="shoe-animated-background"></div>

<div class="content">
    @if (card) {
        <div class="card-placeholder card-placeholder-compact">
            <app-card [card]="card" [compact]="true"></app-card>
        </div>

        <div class="cards-to-burn cards-to-burn-{{ totalToBurnCount }}">
            @for (cardIndex of totalToBurnCount | arrayRange; track cardIndex) {
                <div class="card-placeholder card-placeholder-back" [class.card-placeholder-muted]="cardIndex > burnedCardsCount">
                    @if (cardIndex < burnedCardsCount) {
                        <div class="card-icon-check"></div>
                    } @else {
                        <app-card-message
                            i18n
                            [back]="true"
                            [compact]="totalToBurnCount > compactAfterCount"
                            [muted]="cardIndex > burnedCardsCount"
                            >Face down card</app-card-message
                        >
                    }
                </div>
            }
        </div>
    } @else {
        <div class="card-burn-first">
            <div class="card-placeholder">
                <app-card-message i18n>Face up card</app-card-message>
            </div>
        </div>
    }
</div>
